export enum CognitoError {
  userNotConfirmed = 'User is not confirmed.'
}
